/*!

=========================================================
* 顧客マスタ
=========================================================
*/
import React from "react";

import {
  Card,  CardHeader,  CardBody,  CardTitle,
  Row,  Col,
  FormGroup,  Label,  Input,
} from "reactstrap";
import ReactTable from "react-table-legacy";
import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip'
import Definition from '../../common/Definition';
import WithRole from '../FormParts/ButtonWithRole';
import FormatCode from '../../common/FormatCode';
import InputCheckBox from "../FormParts/InputCheckBox";

const domain = "";

class List extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      pagetitle:"顧客マスタ",
      selectionChanged:"",
      selectionBranchChanged:"",
      customer_id: "",
      customer_branch_id: "",
      customer_name: "",
      customer_branch_name:"",
      customer_branch_tel: "",
      customer_user_name: "",
      customer_user_tel: "",
      customer_data: [],
      customer_branch_data: [],
      customer_user_data: [],
      customer_table:"off",
      show_customer_delete_data : 0,
      show_customer_branch_delete_data : 0,
      show_customer_user_delete_data : 0,
      selectedRowIndex : {},
      selectedBranchRowIndex : {},

      defaultPageSize: 300,
      branchBox: "off",
      userBox: "off",
      selected: null,
      tmp_cnt: "5",
      column:[{ Header: '会社名', accessor: 'customer_name', headerClassName: "text-left", className: "text-left text-top",minWidth:100 },
              { Header: '会社ID', accessor: 'customer_id', show:false, className:'text-left text-top' },
              { Header: '顧客向け利用', accessor: 'customer_system_use_flag', show:true, className:'text-left text-top', width:50 },
              { Header: '詳細', accessor: 'action', headerClassName:'text-center', className:'text-center', minWidth:50, sortable : false},
              { Header: '', accessor: 'symbol', headerClassName:'text-center', className:'text-center', minWidth:20, sortable : false}],
      column_branch:[
              { Header: '会社ID', accessor: 'customer_id', show:false },
              { Header: '支店ID', accessor: 'customer_branch_id',show:false},
              { Header: '支店名', accessor: 'customer_branch_name', headerClassName: "text-center", className: "text-left text-top",minWidth:50  },
              { Header: '顧客向け利用', accessor: 'customer_system_use_flag', show:true, className:'text-left text-top', width:50 },
              { Header: 'TEL', accessor: 'customer_branch_tel', headerClassName: "text-center", className: "text-left text-top",minWidth:50  },
              { Header: '詳細', accessor: 'action', headerClassName:'text-center', className:'text-center', minWidth:50, sortable : false},
              { Header: '', accessor: 'symbol', headerClassName:'text-center', className:'text-center', minWidth:20, sortable : false}
             ],
      column_user:[
                { Header: '担当者名', accessor: 'customer_user_name', headerClassName: "text-center", className: "text-left text-top",minWidth:50  },
//                { Header: 'TEL', accessor: 'customer_user_tel', headerClassName: "text-left ", className: "text-left ",minWidth:50  },
//                { Header: 'アドレス', accessor: 'customer_user_email', headerClassName: "text-left ", className: "text-left ",minWidth:50  },
                  { Header: '連絡先', accessor: '__JOIN_customer_user_contact_information', headerClassName: "text-center", className: "text-left text-top",minWidth:50  },
                  { Header: '詳細', accessor: 'action', headerClassName:'text-center', className:'text-center', minWidth:50, sortable : false},
              ]
    };
    this.setTmp = this.setTmp.bind(this);
    
    this.handle_customer_name = this.handle_customer_name.bind(this)
    this.handle_show_customer_delete_data = this.handle_show_customer_delete_data.bind(this)
    this.handle_customer_branch_name = this.handle_customer_branch_name.bind(this)
    this.handle_customer_branch_tel = this.handle_customer_branch_tel.bind(this)
    this.handle_show_customer_branch_delete_data = this.handle_show_customer_branch_delete_data.bind(this)
    this.handle_customer_user_name = this.handle_customer_user_name.bind(this)
    this.handle_customer_user_tel = this.handle_customer_user_tel.bind(this)
    this.handle_show_customer_user_delete_data = this.handle_show_customer_user_delete_data.bind(this)
    this.enterSearch = this.enterSearch.bind(this)    
    this.symbol = this.symbol.bind(this)
    this.linkButton = this.linkButton.bind(this)
    this.setSelectedDataWithId = this.setSelectedDataWithId.bind(this)
    this.requestData = this.requestData.bind(this)
    // 未承認フラグ
    this.handle_show_customer_unauthorized_data = this.handle_show_customer_unauthorized_data.bind(this)
    this.handle_show_customer_branch_unauthorized_data = this.handle_show_customer_branch_unauthorized_data.bind(this)
    this.handle_show_customer_user_unauthorized_data = this.handle_show_customer_user_unauthorized_data.bind(this)
  }
  componentDidMount(){
    const urlParams = new URLSearchParams(this.props.location.search)
    if(urlParams.has('customer_natural_id') || urlParams.has('customer_branch_natural_id') || urlParams.has('customer_user_natural_id')) {
      const customer_natural_id = urlParams.get('customer_natural_id');
      const customer_branch_natural_id = urlParams.get('customer_branch_natural_id');
      const customer_user_natural_id = urlParams.get('customer_user_natural_id');

      this.setState({
        show_customer_delete_data : customer_natural_id ? 1 : 0,
        show_customer_branch_delete_data : customer_branch_natural_id ? 1 : 0,
        show_customer_user_delete_data : customer_user_natural_id ? 1 : 0
      }, () => {
        this.setSelectedDataWithId({customer_natural_id, customer_branch_natural_id, customer_user_natural_id})
      })
    }
  }
  symbol(value){
    return <span style={{color:"#344675", fontSize:"30px", weight:"500", marginLeft:"-10px", height: "30px", marginTop: "-28px"}} dangerouslySetInnerHTML={{__html:value}}></span>
    // return <div style={{ marginLeft:"-10px", transform: "rotate(45deg)", width:"20px", height:"20px", border:"5px solid #344675", borderBottom: "none", borderLeft: "none"}}></div>
  }
  linkButton(label, toUrl){
    return <Link className="btn btn-secondary small-btn" to={toUrl}>
      <span style={{color:"white", textDecoration:"none"}}>{label}</span>
    </Link>
  }
  enterSearch(name,customer_id,customer_branch_id,e){
    var ENTER = 13;
    if (e.keyCode == ENTER) {
        this.search(name,customer_id,customer_branch_id,e);
    }        
  }  
  dataMap(data) {
    return data.map((prop, key) => {
      return {
        customer_name: prop.customer_name,
        customer_id:prop.ulid,
        customer_system_use_flag: FormatCode.decode("cst_customer_system_use_flag_for_list",prop.customer_system_use_flag),
        delete_flag:prop.delete_flag,
        action: this.linkButton('詳細', "/customer/detail/"+prop.ulid),
        symbol: this.symbol("&#x27AD;")
      }
    });
  }
  dataBranchMap(data){
    return data.map((prop, key) => {
      console.log(prop)
      return {
        customer_branch_name: prop.customer_branch_name,
        //customer_id:prop.customer_id,
        customer_branch_id:prop.ulid,
        customer_system_use_flag: FormatCode.decode("cst_customer_system_use_flag_for_list",prop.customer_system_use_flag),
        customer_branch_tel:prop.customer_branch_tel,
        delete_flag:prop.delete_flag,
//        customer_branch_fax:prop.customer_branch_fax,
        action: this.linkButton('詳細', "/customer/detail/branch/"+prop.ulid),
        symbol: this.symbol("&#x27AD;")
      }
    });
  }
  dataUserMap(data){
    return data.map((prop, key) => {
      return {
        customer_user_name: prop.customer_user_name,
        __JOIN_customer_user_contact_information: <div dangerouslySetInnerHTML={{__html:Definition.item('__JOIN_customer_user_contact_information_with_tel2', prop)}} />,
        // customer_user_tel:prop.customer_user_tel,
        // customer_user_email:prop.customer_user_email,
        action: this.linkButton('詳細', "/customer/detail/user/"+prop.ulid),
      }
    });
  }
  setTmp(){
    if (this.state.tmp_set === "off") {
        this.setState({tmp_set:'on'});
    } else{
        this.setState({tmp_set:'off'});
    }
  }

  setSelectedDataWithId({customer_natural_id, customer_branch_natural_id, customer_user_natural_id}){
    console.log('params', {customer_natural_id, customer_branch_natural_id, customer_user_natural_id})
    const baseUrl = '/api/';
    this.requestData(baseUrl + "customer", {customer_natural_id, show_delete_data : this.state.show_customer_delete_data}, "customer", ()=>{
      if (customer_branch_natural_id){
        this.requestData(baseUrl + "customer/branch", {customer_branch_natural_id, show_delete_data : this.state.show_customer_branch_delete_data}, "customer/branch",()=>{
          if (customer_user_natural_id){
            this.requestData(baseUrl + "customer/user", {customer_user_natural_id, show_delete_data : this.state.show_customer_user_delete_data}, "customer/user",()=>{
              this.setState({
                customer_table: 'on',
                branchBox:'on',
                userBox:'on',
                rowEdit: this.state.customer_data[0].index,
                customer_id: this.state.customer_data[0].customer_id,
                selectedRowIndex: this.state.customer_branch_data[0],
                rowBranchEdit: this.state.customer_branch_data[0],
                customer_branch_id: this.state.customer_branch_data[0].customer_branch_id,
                selectionChanged: true
              });
            })
          }else {
            this.setState({
              customer_table: 'on',
              branchBox:'on',
              rowEdit: this.state.customer_data[0].index,
              selectedRowIndex: this.state.customer_data[0],
              customer_id:this.state.customer_data[0].customer_id,
              selectionChanged: true
            });
          }
        })
      }else {
        this.setState({
          customer_table: 'on',
          selectionChanged: true
        });
      }
    })
  }

  requestData(url, params, name, callback=()=>{}){
    Request.get(url, params, res => {
      switch(name){
        case "customer":
            this.setState({
              customer_data: this.dataMap(res.data)
            }, ()=>callback());
        break;
        case "customer/branch":
            this.setState({
              customer_branch_data: this.dataBranchMap(res.data)
            }, ()=>callback());
        break;
        case "customer/user":
            this.setState({
              customer_user_data:this.dataUserMap( res.data)
            }, ()=>callback());
        break;
      }
    })
  }

  // 検索
  search(name,customer_id,customer_branch_id,e) {
    /* ここは開発者が記述 */
    var url = domain + '/api/'+name;
    console.log(url);
    let params = {};

    switch(name){
      case "customer":
        
        this.setState({
        customer_table: 'on',
        branchBox:'off',
        userBox:'off'
        });

        if(this.state.customer_name != ""){
          params.customer_name = this.state.customer_name;
        }
        params.show_delete_data = this.state.show_customer_delete_data
        params.show_unauthorized_data = this.state.show_customer_unauthorized_data
      break;
      case "customer/branch":
          if(customer_id == ""){
            return false;
          }
          this.setState({branchBox:'on',
                          userBox:'off',
                         customer_id:customer_id,
                         selected: e.index});
          params.customer_ulid = customer_id;
          if(this.state.customer_branch_name != ""){
            params.customer_branch_name = this.state.customer_branch_name;
          }
          if(this.state.customer_branch_tel != ""){
            params.customer_branch_tel = this.state.customer_branch_tel;
          }
          //console.log(url);
          params.show_delete_data = this.state.show_customer_branch_delete_data
          params.show_unauthorized_data = this.state.show_customer_branch_unauthorized_data 
          break;
      case "customer/user":
//          if(customer_id == ""){
//            return false;
//          }
          if(customer_branch_id == ""){
            return false;
          }
          this.setState({branchBox:'on',
                         userBox:'on',
                         customer_branch_id:customer_branch_id,
                         customer_id:customer_id});

//          params.customer_ulid = customer_id;
          params = {
            customer_branch_ulid: customer_branch_id,
            customer_user_name: this.state.customer_user_name?this.state.customer_user_name:undefined,
            customer_user_tel: this.state.customer_user_tel?this.state.customer_user_tel:undefined
          }
          params.show_delete_data = this.state.show_customer_user_delete_data
          params.show_unauthorized_data = this.state.show_customer_user_unauthorized_data

          break;

    }
    console.log(params);
    this.requestData(url, params, name)
  }

  // 初期ロード用
  UNSAFE_componentWillMount(){
    //var query = queryString.parse(this.props.location.search);
    //*　ここは開発者が記述　*/
  }

  handle_customer_name(e){
    this.setState({customer_name: e.target.value});
  }
  handle_customer_branch_name(e){
    this.setState({customer_branch_name: e.target.value});
  }
  handle_customer_branch_tel(e){
    this.setState({customer_branch_tel: e.target.value});
  }
  handle_customer_user_name(e){
    this.setState({customer_user_name: e.target.value});
  }
  handle_customer_user_tel(e){
    this.setState({customer_user_tel: e.target.value});
  }
  handle_show_customer_delete_data(e){
    this.setState({show_customer_delete_data: e.target.checked ? 1 : 0});
  }
  handle_show_customer_branch_delete_data(e){
    this.setState({show_customer_branch_delete_data: e.target.checked ? 1 : 0});
  }
  handle_show_customer_user_delete_data(e){
    this.setState({show_customer_user_delete_data: e.target.checked ? 1 : 0});
  }
  handle_show_customer_unauthorized_data(e){
    this.setState({show_customer_unauthorized_data: e.target.checked ? 1 : 0});
  }
  handle_show_customer_branch_unauthorized_data(e){
    this.setState({show_customer_branch_unauthorized_data: e.target.checked ? 1 : 0});
  }
  handle_show_customer_user_unauthorized_data(e){
    this.setState({show_customer_user_unauthorized_data: e.target.checked ? 1 : 0});
  }

  render() {
    console.log("this.state ", this.state)
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardBody>                
                <Row>
                  <Col md={this.state.header_md?this.state.header_md:"6"}>
                    <CardHeader>
                    <CardTitle tag="h3" className="float-left">{this.state.pagetitle}</CardTitle>
                    </CardHeader>
                  </Col>
                </Row>  
                {/* <Row>
                    <Col md="12" className="margin-auto">
                      <Card>
                        <CardBody className={"search-box " + this.state.tmp_set}>
                        一次保存中のものがあります。
                        </CardBody>
                      </Card>
                    </Col>
                </Row>   */}
                </CardBody>    
                <CardBody>
              <Row className="tables-tab">
                <Col xl="4" lg="6" md="6" sm="6" id="customer">
                  <Card className="card-border">
                    <CardHeader className="sub">
                      <CardTitle tag="h5" className="float-left">会社一覧</CardTitle>
{/*
                      <Button className="float-right" size="sm" href="/customer/add">
                      <i className="fas fa-plus"></i>追加
                      </Button>
*/}
                      <ButtonWithTooltipWithRole
                        button_id="BTN_M1_01_03660"
                        onclick={() => { this.props.history.push("/customer/add/") }}
                        class="float-right btn-facebook customer"
                        id="tmp"
                        icon="fas fa-plus"
                        label="追加"
                        message="会社を追加"
                        size="sm"
                      />                         
                    </CardHeader>                
                    <CardBody className="sub">
                      <FormGroup>
                        <Row>
                          <Col lg="8" md="8" sm="12">
                          <Label for="customer_name" className="search-text-order">会社名：</Label>
                          <Input type="text" onKeyDown={(e) => this.enterSearch("customer","","",e)} name="customer_name" id="customer_name" className="" placeholder="会社名を入力してください" onChange={this.handle_customer_name}/>
                          <Label>
                            <Input type="checkbox" checked={this.state.show_customer_delete_data == 1} onChange={this.handle_show_customer_delete_data} />削除データも表示
                          </Label>
                          <Label>
                            <Input type="checkbox" checked={this.state.show_customer_unauthorized_data == 1} onChange={this.handle_show_customer_unauthorized_data} />未承認データのみ表示
                          </Label>
                          </Col>
                          <Col lg="3" md="3" sm="12">
                          <ButtonWithTooltip
                                            onclick={(e) => this.search("customer","","",e)}
                                            class="float-right btn-search btn-facebook"
                                            id="tmp"
                                            icon="fas fa-search"
                                            link="#"
                                            label="検索"
                                            message="顧客を検索"
                                            size="sm"
                                            /> 
                            {/*
                            <Button className="btn-search" size="sm" onClick={(e) => this.search("customer","","",e)} color="facebook">
                            <i className="fas fa-search" />検索
                            </Button>
                            */}
                          </Col>
                        </Row><br />
                        ※最大{this.state.defaultPageSize}件まで表示しています。
                      </FormGroup>                  
                      <ReactTable
                          data={this.state.customer_data}
                          columns={this.state.column}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='検索してください'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height display-flex "+ this.state.customer_table} 
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                                  this.search("customer/branch",rowInfo.row.customer_id,"",e);

                                  if (rowInfo.index != this.state.rowEdit) {
                                    this.setState({
                                      rowEdit: rowInfo.index,
                                      selectedRowIndex: rowInfo.original,
                                      rowBranchEdit: null,
                                      selectionChanged: this.state.selectionChanged
                                        ? false
                                        : true
                                    });
                                  } else {
                                    this.setState({
                                      rowEdit: null,
                                      rowBranchEdit: null
                                    });
                                  }
//                                  console.log(rowInfo.index);
//                                  console.log(this.state.rowEdit);
                                },
                                style: {
                                  background:
                                    rowInfo.index === this.state.rowEdit ? "#dff2fd" : "",
                                  color:
                                    rowInfo.index === this.state.rowEdit ? "white" : "black",
                                  cursor:
                                    "pointer"
                                }
                              };
                            } else {
                              return {};
                            }
                          }}
                        />

                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4" lg="6" md="6" sm="6" id="customer_branch" className={`${this.state.branchBox}`}>
                  <Card className="card-border">
                    <CardHeader className="sub">
                      <CardTitle tag="h5" className="float-left">支店一覧</CardTitle> 
                        <ButtonWithTooltipWithRole
                          button_id="BTN_M1_01_03710"
                          disabled={this.state.selectedRowIndex.delete_flag === 1}
                          onclick={() => { this.props.history.push("/customer/add/branch/"+this.state.customer_id) }}
                          class="float-right btn-facebook customer"
                          id="tmp"
                          icon="fas fa-plus"
                          label="追加"
                          message="支店を追加"
                          size="sm"
                        />
                      </CardHeader>                
                      <CardBody className="sub">
                        <FormGroup>
                          <Row>
                            <Col lg="8" md="8" sm="12">
                              <Label for="customer_branch_name" className="search-text-order">支店名：</Label>
                              <Input type="text" onKeyDown={(e) => this.enterSearch("customer/branch",this.state.customer_id,"",e)} name="customer_branch_name" id="customer_branch_name" className="" placeholder="支店名を入力してください" onChange={this.handle_customer_branch_name}/>
                              <Label for="customer_branch_tel" className="search-text-order">支店TEL：</Label>
                              <Input type="text" onKeyDown={(e) => this.enterSearch("customer/branch",this.state.customer_id,"",e)} name="customer_branch_tel" id="customer_branch_tel" className="" placeholder="支店TELを入力してください" onChange={this.handle_customer_branch_tel}/>
                              <Label>
                                <Input type="checkbox" checked={this.state.show_customer_branch_delete_data == 1} onChange={this.handle_show_customer_branch_delete_data} />削除データも表示
                              </Label>
                              <Label>
                                <Input type="checkbox" checked={this.state.show_customer_branch_unauthorized_data == 1} onChange={this.handle_show_customer_branch_unauthorized_data} />未承認データのみ表示
                              </Label>
                            </Col>
                            <Col lg="3" md="3" sm="12">
                            <ButtonWithTooltip
                                            onclick={(e) => this.search("customer/branch",this.state.customer_id,"",e)}
                                            class="float-right btn-search btn-facebook"
                                            id="tmp"
                                            icon="fas fa-search"
                                            label="検索"
                                            message="支店を検索"
                                            size="sm"
                                            /> 
                            </Col>
                          </Row><br />
                          ※最大{this.state.defaultPageSize}件まで表示しています。
                        </FormGroup>                  
                        <ReactTable
                          data={this.state.customer_branch_data}
                          columns={this.state.column_branch}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='支店は登録されていません。'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height display-flex"}
                          getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                              return {
                                onClick: e => {
                                  this.search("customer/user",this.state.customer_id,rowInfo.row.customer_branch_id,e)

                                  if (rowInfo.index != this.state.rowBranchEdit) {
                                    this.setState({
                                      rowBranchEdit: rowInfo.index,
                                      selectedBranchRowIndex: rowInfo.original,
                                      selectionBranchChanged: this.state.selectionBranchChanged
                                        ? false
                                        : true
                                    });
                                  } else {
                                    this.setState({
                                      rowBranchEdit: null
                                    });
                                  }
//                                  console.log(rowInfo.index);
//                                  console.log(this.state.rowEdit);
                                },
                                style: {
                                  background:
                                    rowInfo.index === this.state.rowBranchEdit ? "#dff2fd" : "",
                                  color:
                                    rowInfo.index === this.state.rowBranchEdit ? "white" : "black",
                                  cursor:
                                    "pointer"
                                }
                              };
                            } else {
                              return {};
                            }
                          }}
                        />
                        
                      </CardBody>
                    </Card>
                </Col>
                <Col xl="4" lg="6" md="6" sm="6" id="customer_user" className={`${this.state.userBox}`}>
                  <Card className="card-border">
                      <CardHeader className="sub">
                        <CardTitle tag="h5" className="float-left">担当者</CardTitle>
                        <ButtonWithTooltipWithRole
                          button_id="BTN_M1_01_03770"
                          disabled={ this.state.selectedRowIndex.delete_flag === 1 || this.state.selectedBranchRowIndex.delete_flag === 1}
                          onclick={() => { this.props.history.push("/customer/add/user/"+this.state.customer_branch_id) }}
                          class="float-right btn-facebook customer"
                          id="tmp"
                          icon="fas fa-plus"
                          label="追加"
                          message="担当者を追加"
                          size="sm"
                        />                           
                      </CardHeader>                
                      <CardBody className="sub">
                        <FormGroup>
                          <Row>
                            <Col lg="8" md="8" sm="12">
                              <Label for="customer_user_name" className="search-text-order">担当者名：</Label>
                              <Input type="text" onKeyDown={(e) => this.enterSearch("customer/user",this.state.customer_id,this.state.customer_branch_id,e)}  name="customer_user_name" id="customer_user_name" className="" placeholder="担当者名を入力してください" onChange={this.handle_customer_user_name}/>
                              <Label for="customer_user_tel" className="search-text-order">担当者TEL：</Label>
                              <Input type="text" onKeyDown={(e) => this.enterSearch("customer/user",this.state.customer_id,this.state.customer_branch_id,e)}  name="customer_user_tel" id="customer_user_tel" className="" placeholder="担当者TELを入力してください" onChange={this.handle_customer_user_tel}/>
                              <Label>
                                <Input type="checkbox" checked={this.state.show_customer_user_delete_data == 1} onChange={this.handle_show_customer_user_delete_data} />削除データも表示
                              </Label>
                              <Label>
                                <Input type="checkbox" checked={this.state.show_customer_user_unauthorized_data == 1} onChange={this.handle_show_customer_user_unauthorized_data} />未承認データのみ表示
                              </Label>
                            </Col>
                            <Col lg="3" md="3" sm="12">
                            <ButtonWithTooltip
                                            onclick={(e) => this.search("customer/user",this.state.customer_id,this.state.customer_branch_id,e)}
                                            class="float-right btn-search btn-facebook"
                                            id="tmp"
                                            icon="fas fa-search"
                                            label="検索"
                                            message="担当者を検索"
                                            size="sm"
                                            />                       
                            </Col>
                          </Row>
                          <br />
                          ※最大{this.state.defaultPageSize}件まで表示しています。

                        </FormGroup>                  
                        <ReactTable
                          data={this.state.customer_user_data}
                          columns={this.state.column_user}
                          defaultPageSize={this.state.defaultPageSize}
                          minRows={2}
                          filterable={false}
                          showPaginationTop={false}
                          showPaginationBottom={false}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='担当者は登録されていません。'
                          pageText=''
                          ofText='/'
                          // sortable={false}
                          className={"-highlight custom-table-with-max-height display-flex"} 
                        />
                      </CardBody>
                    
                  </Card>
                </Col>
                </Row>
                </CardBody>            
              </Card>
            </Col>            
          </Row>
        </div>
      </>
    );
  }
}

export default List;
